exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".v3-dialog-footer{border-top:1px solid #ccc;display:flex;height:55px;align-items:center;justify-content:flex-end;padding-left:10px;padding-right:10px}.v3-dialog .button+.button{margin-left:10px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader/lib!./src/componentsv3/Dialog/components/DialogFooter/style.css
 ** module id = 1205
 ** module chunks = 0
 **/